module.exports = __webpack_public_path__ + "static/media/Human_Walk_030_720.aca92eb5.jpg";